import React from 'react';
import { opacify } from 'polished';

import { MARK_TYPE as MT, } from 'shared/constants/slate';
import { BASE_COLOR as BC } from 'shared/constants/colors';
import { classes as cn } from 'shared/styles';


const Bold = props => <strong>{props.children}</strong>;
const Italic = props => <em>{props.children}</em>;
const Strikethru = props => <del>{props.children}</del>;
const Code = props => (
  <code className={cn.codeMark} spellCheck={false}>
    {props.children}
  </code>
);

const defaultHiColor = opacify(-0.7, BC.red);
const Highlighted = ({
  color = defaultHiColor,
  children,
}) => {
  return (
    <span style={{ background: color }}>
      {children}
    </span>
  );
};

const Nbsp = ({ count = 1 }) => (
  <span>
    {Array(count).fill().map((_, i) => '\u00A0')}
  </span>
);


const renderDefaultMark = (props) => {
  const { children, mark } = props;
  switch (mark.type) {
    case MT.bold: return <Bold children={children} />;
    case MT.italic: return <Italic children={children} />;
    case MT.strikethrough: return <Strikethru children={children} />;
    case MT.highlighted: return <Highlighted children={children} />;
    case MT.code: return <Code children={children} />;
    case MT.nbsp:
      return (
        <Nbsp
          count={mark.data.get('count')}
          children={children}
        />
      );
    default: return;
  }
};

export {
  // TODO: Why do these need to be exported..?
  Bold,
  Italic,
  Strikethru,
  Highlighted,
  Nbsp,

  renderDefaultMark,
}



// WEBPACK FOOTER //
// ./src/components/slate/marks.js